"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultArrowSize = exports.FlyoutArrow = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
function startsWith(str, prefix) {
  return str.startsWith(prefix);
}
const defaultArrowSize = 4;
exports.defaultArrowSize = defaultArrowSize;
const FlyoutArrow = (0, _styled.default)("div")({
  width: 0,
  height: 0,
  borderStyle: "solid"
}, _ref => {
  let {
    size = defaultArrowSize
  } = _ref;
  return {
    borderWidth: `${size}px`
  };
},
// Choose the right border color based on positioning.
_ref2 => {
  let {
    backgroundColor,
    placement
  } = _ref2;
  return {
    borderRightColor: startsWith(placement, "right") && backgroundColor || "transparent",
    borderLeftColor: startsWith(placement, "left") && backgroundColor || "transparent",
    borderTopColor: startsWith(placement, "top") && backgroundColor || "transparent",
    borderBottomColor: startsWith(placement, "bottom") && backgroundColor || "transparent"
  };
},
// Offset the arrow a bit to account for its size.
_ref3 => {
  let {
    placement,
    size = defaultArrowSize
  } = _ref3;
  return {
    bottom: startsWith(placement, "top") ? `-${size * 2}px` : "initial",
    top: startsWith(placement, "bottom") ? `-${size * 2}px` : "initial",
    right: startsWith(placement, "left") ? `-${size * 2}px` : "initial",
    left: startsWith(placement, "right") ? `-${size * 2}px` : "initial"
  };
});
exports.FlyoutArrow = FlyoutArrow;
//# sourceMappingURL=FlyoutArrow.js.map